"use client";import{jsxs as t,jsx as e}from"react/jsx-runtime";import{twJoin as o}from"tailwind-merge";import{List as i}from"../List/List.js";import{useDropdown as n}from"../../../hooks/useDropdown.js";import{TextButton as s}from"./TextButtonDropdown.parts.js";
/**
 * 텍스트 버튼 형태의 드롭다운 컴포넌트입니다.
 *
 * @param {Object} props
 * @param {Array<{key: string, value: string, leadingIcon?: React.ReactNode}>} props.items - 드롭다운에 표시될 항목들의 배열
 * @param {{key: string, value: string, leadingIcon?: React.ReactNode}} props.selectedItem - 현재 선택된 항목 ({key, value, leadingIcon}[])
 * @param {(item: {key: string, value: string, leadingIcon?: React.ReactNode}) => void} props.onItemClick - 항목 클릭 시 실행될 콜백 함수 (item: {key, value, leadingIcon} => void)
 * @param {boolean} [props.alignRight=false] - 드롭다운 메뉴를 오른쪽 정렬할지 여부
 * @param {boolean} [props.disabled=false] - 드롭다운 메뉴를 비활성화할지 여부
 *
 * @example
 * const items = [
 *   { key: '1', value: '옵션 1' },
 *   { key: '2', value: '옵션 2', leadingIcon: <Icon /> },
 *   { key: '3', value: '옵션 3' }
 * ];
 *
 * const [selected, setSelected] = useState(items[0]);
 *
 * return (
 *   <TextButtonDropdown
 *     items={items}
 *     selectedItem={selected}
 *     onItemClick={setSelected}
 *     alignRight={false}
 *     disabled={item.length === 0}
 *   />
 * );
 */const l=({items:l,selectedItem:d,onItemClick:a,alignRight:r=!1,disabled:m=!1})=>{const{isListOpen:c,ref:u,focusedIndex:p,handleItemClick:f,toggleListOpen:x,handleKeyDown:g}=n({items:l,onItemClick:a});/*#__PURE__*/
return t("div",{"data-testid":"design-system-text-button-dropdown",className:"relative flex w-fit flex-col gap-1 outline-none",ref:u,onKeyDown:g,tabIndex:0,children:[
/*#__PURE__*/e(s,{disabled:m,value:d.value,"data-testid":"design-system-text-button-dropdown--textButton",isListOpen:c,onClick:x}),c&&/*#__PURE__*/e("div",{className:o("absolute -bottom-2 z-40 translate-y-full transform transition-all",r?"right-0":"left-0 "),"data-testid":"design-system-text-button-dropdown--list",children:/*#__PURE__*/e(i.Root,{className:"max-h-full min-w-40 overflow-y-visible",children:l.map(((t,o)=>/*#__PURE__*/e(i.Item,{text:t.value,leadingIcon:t.leadingIcon,onClick:()=>f(t),selected:t.key===(null==d?void 0:d.key),isFocused:o===p},t.key)))})})]})};export{l as TextButtonDropdown};
